"use client"

import Text from "@/components/common/Typography/Text"
import { useTETranslation } from "@/hooks/app/useTETranslation"
import { AmenityCategory, AmenityItem } from "@/utils/flight/getSegmentAmenities"
import { IconDefinition } from "@fortawesome/fontawesome-svg-core"
import {
  faChair,
  faPlane,
  faPlug,
  faTableCells,
  faTv,
  faUtensils,
  faWifi,
  faWineGlass,
} from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

export const AMENITY_ICON: Record<AmenityCategory, IconDefinition> = {
  food: faUtensils,
  beverage: faWineGlass,
  entertainment: faTv,
  wifi: faWifi,
  power: faPlug,
  aircraft: faPlane,
  layout: faTableCells,
  seat: faChair,
}

type FlightAmenitiesGridProps = {
  items: AmenityItem[]
  className?: string
}

const FlightAmenitiesGrid = ({ items, className }: FlightAmenitiesGridProps) => {
  const { getTranslatedText } = useTETranslation()

  if (!items.length) {
    return null
  }

  return (
    <div className={`flights__amenities-grid${className ? ` ${className}` : ""}`}>
      {items.map((item) => (
        <div key={item.category} className="flights__amenities-grid-item">
          <FontAwesomeIcon
            icon={AMENITY_ICON[item.category]}
            className="flights__amenities-grid-icon"
          />
          <Text className="flights__amenities-grid-text">
            {getTranslatedText(item.valueVi, item.valueEn)}
          </Text>
        </div>
      ))}
    </div>
  )
}

export default FlightAmenitiesGrid
